<script lang="ts">
    import Footer from "./footer/Footer.svelte";
    import Head from "./header/Head.svelte";
    import Navbar from "./header/Navbar.svelte";
    import { _ } from "svelte-i18n";
</script>

<svelte:head>
    <title>ANYWAYS | {$_("contact.pagetitle")}</title>
</svelte:head>

<Navbar isDark={false} isFluid={false} />

<section class="pt-8 pt-md-11 pb-8 pb-md-14">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <h2 class="font-weight-bold">{$_("contact.title")}</h2>

                <p class="font-size-lg text-muted">
                    {$_("contact.description")}
                </p>

                <p class="font-size-lg text-muted mb-7 mb-md-9" />
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10">
                <form
                    name="sentMessage"
                    id="contactForm"
                    action="https://formspree.io/f/xoqpblog"
                    method="POST"
                    novalidate>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="contactName">{$_("contact.form.fullname.label")}</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="name"
                                    id="name"
                                    required
                                    data-validation-required-message="{$_("contact.form.fullname.message")}"
                                    placeholder="{$_("contact.form.fullname.placeholder")}" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-5">
                                <label for="contactEmail">{$_("contact.form.email.label")}</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    id="email"
                                    required
                                    data-validation-required-message="{$_("contact.form.email.message")}"
                                    placeholder="{$_("contact.form.email.placeholder")}" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group mb-7 mb-md-9">
                                <label for="contactMessage">
                                    {$_("contact.form.message.label")}
                                </label>
                                <textarea
                                    class="form-control"
                                    id="message"
                                    name="message"
                                    required
                                    data-validation-required-message="{$_("contact.form.message.message")}"
                                    rows="5"
                                    placeholder="{$_("contact.form.message.placeholder")}" />
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button
                                type="submit"
                                value="Send"
                                class="btn btn-primary lift">
                                {$_("contact.form.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<div class="position-relative">
    <div class="shape shape-bottom shape-fluid-x text-dark">
        <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ><path
                d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
                fill="currentColor" /></svg>
    </div>
</div>

<Footer bgClass="bg-dark" />
